// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.99.6/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.99.6/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ant-layout-footer.nkl-deck-footer {
  position: relative;
  padding: 1rem 1rem 3rem;
  text-align: center;
  color: #fff;
  background: #363e42;
}
.ant-layout-footer.nkl-deck-footer .nkl-deck-footer-links-container {
  opacity: 1;
  transition: opacity 0.5s ease-in-out;
}
.ant-layout-footer.nkl-deck-footer .nkl-deck-footer-links-container.nkl-deck-footer-loading {
  opacity: 0;
}
.ant-layout-footer.nkl-deck-footer .nkl-deck-footer-links {
  margin: 1rem 0;
  padding: 0;
  list-style-type: none;
}
.ant-layout-footer.nkl-deck-footer .nkl-deck-footer-links a {
  color: #fff;
  text-decoration: underline;
}
.ant-layout-footer.nkl-deck-footer .nkl-deck-footer-copyright {
  margin: 1rem 0;
  font-size: 12px;
}
.ant-layout-footer.nkl-deck-footer .nkl-deck-footer-loading {
  visibility: hidden;
}
.ant-layout-footer.nkl-deck-footer .nkl-deck-footer-loader {
  display: none;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
}
.ant-layout-footer.nkl-deck-footer .nkl-deck-footer-loader.nkl-deck-footer-loading {
  display: block;
  visibility: visible;
}
.ant-layout-footer.nkl-deck-footer .nkl-deck-footer-loader .nkl-deck-footer-spinner-container {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 48px;
  height: 48px;
  transform: translate(-50%, -50%);
}
.ant-layout-footer.nkl-deck-footer .nkl-deck-footer-loader .nkl-deck-footer-spinner {
  width: 100%;
  fill: #fff;
  opacity: 0.5;
  animation: spin 0.5s infinite linear;
}
@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
`, "",{"version":3,"sources":["webpack://./src/deck/footer/footer.less"],"names":[],"mappings":"AAAA;EACI,kBAAA;EACA,uBAAA;EACA,kBAAA;EACA,WAAA;EACA,mBAAA;AACJ;AANA;EAQQ,UAAA;EACA,oCAAA;AACR;AACQ;EACI,UAAA;AACZ;AAbA;EAiBQ,cAAA;EACA,UAAA;EACA,qBAAA;AADR;AAlBA;EAsBY,WAAA;EACA,0BAAA;AADZ;AAtBA;EA4BQ,cAAA;EACA,eAAA;AAHR;AA1BA;EAiCQ,kBAAA;AAJR;AA7BA;EAqCQ,aAAA;EACA,kBAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;AALR;AAOQ;EACI,cAAA;EACA,mBAAA;AALZ;AAzCA;EAkDY,kBAAA;EACA,QAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EACA,gCAAA;AANZ;AAjDA;EA2DY,WAAA;EACA,UAAA;EACA,YAAA;EACA,oCAAA;AAPZ;AAWI;EACI;IACI,uBAAA;EATV;EAWM;IACI,yBAAA;EATV;AACF","sourcesContent":[".ant-layout-footer.nkl-deck-footer {\n    position: relative;\n    padding: 1rem 1rem 3rem;\n    text-align: center;\n    color: #fff;\n    background: #363e42;\n\n    .nkl-deck-footer-links-container {\n        opacity: 1;\n        transition: opacity 0.5s ease-in-out;\n\n        &.nkl-deck-footer-loading {\n            opacity: 0;\n        }\n    }\n\n    .nkl-deck-footer-links {\n        margin: 1rem 0;\n        padding: 0;\n        list-style-type: none;\n\n        a {\n            color: #fff;\n            text-decoration: underline;\n        }\n    }\n\n    .nkl-deck-footer-copyright {\n        margin: 1rem 0;\n        font-size: 12px;\n    }\n\n    .nkl-deck-footer-loading {\n        visibility: hidden;\n    }\n\n    .nkl-deck-footer-loader {\n        display: none;\n        position: absolute;\n        top: 0;\n        right: 0;\n        bottom: 0;\n        left: 0;\n\n        &.nkl-deck-footer-loading {\n            display: block;\n            visibility: visible;\n        }\n\n        .nkl-deck-footer-spinner-container {\n            position: absolute;\n            top: 50%;\n            left: 50%;\n            width: 48px;\n            height: 48px;\n            transform: translate(-50%, -50%);\n        }\n\n        .nkl-deck-footer-spinner {\n            width: 100%;\n            fill: #fff;\n            opacity: 0.5;\n            animation: spin 0.5s infinite linear;\n        }\n    }\n\n    @keyframes spin {\n        from {\n            transform: rotate( 0deg );\n        }\n        to {\n            transform: rotate( 360deg );\n        }\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
